module.exports = __webpack_public_path__ + "static/img/default.c6421a72.svg";